import type { MainWeapon, SideWeapon, UpgradeId } from "./types";
export const MAIN_WEAPONS: { id: MainWeapon; name: string; detail: string }[] =
  [
    { id: "straight", name: "集中直射", detail: "集中火力 · 精准击破" },
    { id: "double", name: "平行双列", detail: "双线并进 · 均衡覆盖" },
    { id: "fan", name: "扇形散射", detail: "展开弹幕 · 清理敌群" },
  ];
export const SIDE_WEAPONS: {
  id: SideWeapon;
  name: string;
  cost: number;
  achievement?: string;
  detail: string;
}[] = [
  { id: "wing", name: "僚机双枪", cost: 0, detail: "两翼补充直线火力" },
  { id: "orbit", name: "环绕弹", cost: 0, detail: "环绕机身阻挡敌弹" },
  {
    id: "homing",
    name: "追踪弹",
    cost: 0,
    achievement: "首次击败 Boss",
    detail: "转向追踪最近敌机",
  },
  {
    id: "boomerang",
    name: "回旋弹",
    cost: 0,
    achievement: "单局生存10分钟",
    detail: "往返穿越敌阵",
  },
  { id: "split", name: "星爆分裂弹", cost: 66, detail: "命中后向四周分裂" },
  { id: "arc", name: "链式电弧", cost: 99, detail: "连接附近敌人" },
];
export interface Upgrade {
  id: UpgradeId;
  name: string;
  detail: string;
  cap: number;
  group: "通用" | "主炮" | "副武器";
}
const generic: [UpgradeId, string, string, number][] = [
  ["attack", "浓墨火力", "攻击提高15%", 0],
  ["rate", "疾速运笔", "射击间隔缩短，上限8级", 8],
  ["critical", "灵光一击", "暴击几率提高5%", 10],
  ["health", "厚实画纸", "生命上限增加20并回复20", 0],
  ["repair", "修补涂鸦", "回复35%最大生命", 0],
  ["shield", "彩墨护盾", "获得25点额外护盾", 0],
  ["speed", "轻盈机翼", "移动速度提高8%", 8],
  ["experience", "创作灵感", "经验获得提高10%", 10],
  ["cooldown", "墨水回流", "墨爆冷却缩短", 10],
  ["grace", "余墨保护", "受击保护延长", 5],
  ["armor", "纸层装甲", "减少受到的伤害", 8],
  ["regen", "自愈画纸", "每秒缓慢修复生命", 5],
];
const main: [UpgradeId, string, string, number][] = [
  ["lanes", "多重弹道", "增加一条主炮弹道", 4],
  ["burst", "连续点画", "增加一次连续发射", 2],
  ["pierce", "穿透笔锋", "子弹额外穿透一个目标", 4],
  ["size", "粗笔弹体", "弹体和命中范围扩大", 4],
  ["velocity", "飞速墨点", "子弹速度提高", 5],
  ["push", "冲击笔触", "击退普通敌机", 4],
];
export const UPGRADES: Upgrade[] = [
  ...generic.map(([id, name, detail, cap]) => ({
    id,
    name,
    detail,
    cap,
    group: "通用" as const,
  })),
  ...main.map(([id, name, detail, cap]) => ({
    id,
    name,
    detail,
    cap,
    group: "主炮" as const,
  })),
  ...SIDE_WEAPONS.map((s) => ({
    id: s.id,
    name: s.name,
    detail: s.detail,
    cap: 5,
    group: "副武器" as const,
  })),
];
export const upgradeInfo = (id: UpgradeId) =>
  UPGRADES.find((u) => u.id === id)!;
export const ENEMIES = [
  "直冲纸燕",
  "蛇形彩带",
  "横移扫射",
  "瞄准铅笔",
  "环形花火",
  "护盾纸甲",
  "分裂纸团",
  "召唤画匣",
];
export const BOSSES = ["纸翼轰炸机", "墨水章鱼", "折纸堡垒"];
export const SCENES = ["纸上云海", "彩绘都市", "星空画卷"];
export const starsFor = (tick: number, bosses: number) =>
  Math.floor(tick / 3600) * 2 + bosses * 5;
